<script lang="ts" setup>

withDefaults(defineProps<{
  text: string;
  icon?: string;
}>(), {
  text: 'button',
  icon: undefined,
});

</script>

<template>
  <div class="tag" tabindex="0">
    <img v-if="icon" :src="icon" alt="Rate icon" class="tag__icon" >
    <p :aria-label="`Item tag - ${text}`">
      {{ text }}
    </p>
  </div>
</template>

<style>
@import '../../../assets/css/mixins/_mixins.index.pcss';

.tag {
  @mixin body-small;
  color: var(--theme-text-color);
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 46px;
  background-color: theme('colors.yellow.20');
  width: fit-content;

  &:focus {
    outline: 2px solid var(--theme-text-color);
  }
  &__icon {
    margin-right: 3px;
  }
}
</style>
